import React, {
  useMemo,
  useEffect,
  useCallback,
  useReducer,
  useState,
} from 'react';
import cx from 'classnames';
import { Icon } from 'js/components';
import CapabilityTreeNode from './CapabilityTreeNode';
import { treeStateReducer, getInitialTreeState, findItem } from './tree';
import { useSelectorContext } from './SelectorContext';

import { TreeContext } from './TreeContext';

import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';

import styles from './CapabilitySelector.module.scss';

function CapabilitySet({ capabilitySet }) {
  const { activeItem, navigateToItem } = useSelectorContext();
  const [isOpen, setIsOpen] = useState(true);

  const path = useMemo(() => [capabilitySet], [capabilitySet]);

  const [state, updateState] = useReducer(
    treeStateReducer,
    capabilitySet,
    getInitialTreeState
  );

  useEffect(() => {
    updateState({ type: 'refresh', capabilitySet });
  }, [capabilitySet]);

  const findTreeItem = useCallback(
    (itemId) => {
      return findItem(state, itemId);
    },
    [state]
  );

  const navigateToSet = useCallback(() => {
    navigateToItem({ capabilitySet, path: [] });
  }, [navigateToItem, capabilitySet]);

  const context = useMemo(
    () => ({
      dispatch: updateState,
      find: findTreeItem,
    }),
    [updateState, findTreeItem]
  );

  const handleToggleOpen = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const isActiveItem = useMemo(() => {
    return activeItem?.id === capabilitySet.id;
  }, [activeItem, capabilitySet]);

  const toggleButtonProps = useMemo(() => {
    return { icon: faCaretRight, transform: isOpen ? 'rotate-90' : '' };
  }, [isOpen]);

  return (
    <TreeContext.Provider value={context}>
      <div>
        <div
          className={cx(styles['node-body'], {
            [styles['active-item']]: isActiveItem,
          })}
        >
          <div className={styles['node-toggle']}>
            <button
              className={styles['btn-node-toggle']}
              onClick={handleToggleOpen}
            >
              <Icon {...toggleButtonProps} fixedWidth />
            </button>
          </div>
          <div className={styles['node-toggle']}></div>
          <div className={styles['node-name']}>
            <button className={styles['btn-node-name']} onClick={navigateToSet}>
              {capabilitySet.name}
            </button>
          </div>
        </div>
        <div className={cx(styles['capability-tree'], { 'd-none': !isOpen })}>
          {capabilitySet.capabilities.map((c) => (
            <CapabilityTreeNode
              key={c.id}
              capability={c}
              path={path}
              depth={0}
            />
          ))}
        </div>
      </div>
    </TreeContext.Provider>
  );
}

export default CapabilitySet;
